module.exports = __webpack_public_path__ + "img/erilanerweima.b2502638.jpg";